export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/cant-find-car.d57c8412.svg","height":251,"width":602,"blurWidth":0,"blurHeight":0};